import { FC } from 'react';

const Footer: FC = () => {
  return (
    <footer className='py-12 border-t border-border bg-background'>
      <div className='container mx-auto px-4'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-12'>
          <div>
            <div className='flex items-center space-x-2 mb-4'>
              <div className='h-8 w-8 rounded-md bg-primary flex items-center justify-center'>
                <span className='text-primary-foreground font-bold text-xs'>RS</span>
              </div>
              <span className='font-bold text-lg text-foreground'>ResumeReady</span>
            </div>
            <p className='text-sm text-muted-foreground'>
              Create ATS-optimized resumes in minutes.
            </p>
          </div>
          <div>
            <h4 className='font-bold mb-4 text-foreground'>Features</h4>
            <ul className='space-y-3 text-sm text-muted-foreground'>
              {['Templates', 'ATS Optimization', 'PDF Export', 'AI Suggestions'].map(
                (item) => (
                  <li key={item}>
                    <a href='#' className='hover:text-primary transition-smooth'>
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>
          <div>
            <h4 className='font-bold mb-4 text-foreground'>Company</h4>
            <ul className='space-y-3 text-sm text-muted-foreground'>
              {['About Us', 'Careers', 'Privacy', 'Terms'].map((item) => (
                <li key={item}>
                  <a href='#' className='hover:text-primary transition-smooth'>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className='font-bold mb-4 text-foreground'>Get Started</h4>
            <button className='w-full bg-primary text-primary-foreground rounded-md px-4 py-3 text-sm font-medium transition-smooth hover:bg-primary/90'>
              Start Free Trial
            </button>
          </div>
        </div>
        <div className='mt-12 pt-8 border-t border-border text-center text-sm text-muted-foreground'>
          © 2025 ResumeReady. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
